import {useEffect} from 'react';
import useViewPresentedEvent from '@contentlab/hooks/analytics/use-view-presented-event';
import useContentLabPageName from '@contentlab/hooks/use-content-lab-page-name';
import contentLabStore, {
  AssetErrors,
  contentLabActions,
} from '@contentlab/stores/contentLabStore';
import {CONTENT_LAB_VIEW_NAMES} from '@/lib/analytics/analyticsConstants';

function useReportAssetErrors({assetErrors}: {assetErrors: AssetErrors[]}) {
  const pageName = useContentLabPageName();
  const {viewPresented} = useViewPresentedEvent();

  useEffect(() => {
    const {assetUploadProcessIdsMap} = contentLabStore.getState();
    assetErrors.forEach((assetError) => {
      if (assetUploadProcessIdsMap[assetError.assetId]) {
        const eventPayload = {
          presentation_id: '',
          interaction_id: '',
          flow_id: '',
          view_type: 'error_message',
          view_name: CONTENT_LAB_VIEW_NAMES.ASSET_ERROR,
          view_location: pageName,
          view_details: JSON.stringify({
            asset_id: assetError.assetId,
            error_codes: assetError.errorCodes,
            process_id: assetUploadProcessIdsMap[assetError.assetId],
          }),
          source: '',
        };

        viewPresented(eventPayload);

        contentLabActions.removeAssetUploadProcessId({
          assetId: assetError.assetId,
        });
      }
    });
  }, [assetErrors, pageName]);
}

export default useReportAssetErrors;
